import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class ScrollDialog extends React.Component {
  state = {
    open: false,
    scroll: 'paper',
  };

  handleClickOpen = scroll => () => {
    this.setState({ open: true, scroll });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    return (
      <div>
        <Button size="large" color="primary" className="infoButton" onClick={this.handleClickOpen('paper')}>Información Útil</Button>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          scroll={this.state.scroll}
          aria-labelledby="scroll-dialog-title"
          maxWidth="md"
        >
          <DialogTitle id="scroll-dialog-title">Requerimientos Técnicos recomendados para un óptimo funcionamiento</DialogTitle>
          <DialogContent>
            <DialogContentText>
             

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} size="large" color="primary" className="infoButton">
              ACEPTAR
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default ScrollDialog;